import { Component, Input, OnInit, ElementRef, AfterViewInit, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { PhxSkeletonBackground, PhxSkeletonDirection, PhxSkeletonPosition, PhxSkeletonShape } from './phx-skeleton.type';
import { PHX_BACKGROUND } from '../../constants';

@Component({
  selector: 'phx-skeleton',
  styleUrls: ['./phx-skeleton.component.scss'],
  templateUrl: './phx-skeleton.component.html',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'phx-skeleton',
    '[class.phx-skeleton-bg-dark]': 'phxBackground === PHX_BACKGROUND.DARK',
  }
})

export class PhxSkeletonComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() public phxCount: number = 1;
  @Input() public phxShape: PhxSkeletonShape = 'square';
  @Input() public phxPosition: PhxSkeletonPosition = 'left';
  @Input() public phxWidth: string = '28px';
  @Input() public phxHeight: string = '28px';
  @Input() public phxDirection: PhxSkeletonDirection = 'row';
  @Input() public phxSpacing: string;
  @Input() public phxMargin: string;
  @Input() public phxShouldShowAnimation: boolean = true;
  @Input() public phxBackground: PhxSkeletonBackground = PHX_BACKGROUND.STANDARD;
  
  public readonly PHX_BACKGROUND = PHX_BACKGROUND;
  public skeletons: number[] = [];
  
  private el: HTMLElement;

  constructor(private _nativeElement: ElementRef) {
    this.el = _nativeElement.nativeElement;
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.setStyleAttributes();
    if(changes.phxCount) {
      this.skeletons = new Array(this.phxCount).fill(0);
    }
  }

  public ngOnInit(): void {
    this.skeletons = new Array(this.phxCount).fill(0);
  }

  public ngAfterViewInit(): void {
    this.setStyleAttributes();
  }

  // TODO: Refactor this to do this via scss. This is currently being done via code to allow for dynamic changes to the skeleton's appearance, but it would be ideal if this could be done purely via scss and css variables.
  private setStyleAttributes(): void {
    this.el.style.setProperty('--phx-skeleton-width', this.phxWidth);
    this.el.style.setProperty('--phx-skeleton-height', this.phxHeight);
    this.el.style.setProperty('--phx-skeleton-direction', this.phxDirection);
    this.el.style.setProperty('--phx-skeleton-margin', this.phxMargin);
    if(this.phxShape === 'circle') {
      this.el.style.setProperty('--skeleton-border-radius', 'var(--phx-web-dimension-radius-half)');
    } else if(this.phxShape === 'rounded') {
      this.el.style.setProperty('--skeleton-border-radius', 'var(--phx-web-radius-small)');
    } else {
      this.el.style.setProperty('--skeleton-border-radius', 'var(--phx-web-radius-extra-small)');
    }
    if(this.phxPosition === 'right') {
      this.el.style.setProperty('--phx-skeleton-position', 'flex-end');
    } else if (this.phxPosition === 'left'){
      this.el.style.setProperty('--phx-skeleton-position', 'flex-start');
    } else {
      this.el.style.setProperty('--phx-skeleton-position', 'center');
    }
  }
}